/* WF-15 · internal admin — the shell the ten surfaces share.
   Frames live in the merchant AppShell (WF-15 sheet, « Comment lire ces
   fiches ») — this adds only the internal surface switcher, which the
   wireframe assumes exists and does not draw. Static tier throughout:
   rendered and reachable, never wired. */
import { NavLink, Outlet, useOutletContext } from 'react-router-dom'
import { Button, EmptyState, Note, Skeleton } from '@/ui'
import { useAdminSurfaces, type AdminSurfaces } from './api'

export const ADMIN_SURFACES = [
  { frame: 'AD-01', to: '/admin', end: true, label: 'Workspaces' },
  { frame: 'AD-02', to: '/admin/entitlement', label: 'Entitlement — accorder / modifier' },
  { frame: 'AD-03', to: '/admin/pilote', label: 'Pilote Valessio — provisionnement' },
  { frame: 'AD-04', to: '/admin/litiges', label: 'Litiges cadeaux & accès support' },
  { frame: 'AD-05', to: '/admin/fraude', label: 'File fraude & exceptions appareil' },
  { frame: 'AD-06', to: '/admin/guides', label: 'Guides destinations — registre' },
  { frame: 'AD-07', to: '/admin/email', label: 'Opérations e-mail & modèles' },
  { frame: 'AD-08', to: '/admin/plateforme', label: 'Drapeaux, files & incidents' },
  { frame: 'AD-09', to: '/admin/sauvegardes', label: 'Sauvegardes, audit & SLO' },
  { frame: 'AD-10', to: '/admin/portes', label: 'Portes de lancement' },
] as const

export default function AdminShell() {
  const { data, isPending, isError, refetch } = useAdminSurfaces()

  return (
    <div style={{ display: 'grid', gap: 18, maxWidth: 880 }}>
      {/* Ruled 30/08: /admin lives in the merchant AppShell for the test
          interface; one page-level banner line marks it, not a second shell. */}
      <Note tone="candour">« Surface interne BMR — hors produit marchand »</Note>

      <nav className="tabs" aria-label="Administration interne">
        {ADMIN_SURFACES.map(s => (
          <NavLink key={s.frame} to={s.to} end={'end' in s ? s.end : false}
            data-frame-link={s.frame}
            className={({ isActive }) => 'tab' + (isActive ? ' on' : '')}>
            {s.label}
          </NavLink>
        ))}
      </nav>

      {isPending && (
        <div style={{ display: 'grid', gap: 10 }}>
          <Skeleton width="42%" /><Skeleton /><Skeleton width="65%" />
        </div>
      )}
      {isError && (
        <EmptyState title="Impossible de charger l’administration."
          why="Votre connexion a peut-être sauté — rien n’a été perdu."
          action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
      )}
      {data && <Outlet context={data} />}
    </div>
  )
}

export const useAdmin = () => useOutletContext<AdminSurfaces>()
